import { buildDestinationListArgs, buildDestinationListReturn } from './model';

export const buildDestinationList = ({
  destinations,
  addConnectorData,
  editDestination,
  chosenDestination,
}: buildDestinationListArgs): buildDestinationListReturn[] => {
  const connectorDestinations = addConnectorData.destinations?.map(
    (destination) => destination.destinationName
  );

  return destinations
    .filter(
      (destination) =>
        chosenDestination?.destinationName === destination.name ||
        !connectorDestinations?.includes(destination.name) ||
        editDestination === destination.name
    )
    .map((destination) => ({
      ...destination,
      image: `/assets/connector-icons/regular-logos/${destination.provider}.svg`,
    }));
};
